import React, { useState } from 'react';
import { useCart } from '../../context/CartContext';
import toast from 'react-hot-toast';
import './BrandMenuCard.css';

const BrandMenuCard = ({ item, brand }) => {
  const { addToCart } = useCart();
  const [added, setAdded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const primary = brand?.primaryColor || '#111';

  const handleAdd = (e) => {
    if (e) e.stopPropagation();
    addToCart(item);
    setAdded(true);
    toast.success(`${item.name} added to enquiry`);
    setTimeout(() => setAdded(false), 1500);
    setModalOpen(false);
  };

  return (
    <>
      <div className="bmc" onClick={() => setModalOpen(true)}>
        <div className="bmc-img">
          {item.imageUrl ? <img src={item.imageUrl} alt={item.name} /> : <div className="bmc-placeholder"><svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21,15 16,10 5,21"/></svg></div>}
          <span className="bmc-category" style={{ background: primary }}>{item.category}</span>
          <div className="bmc-hover">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
            View Details
          </div>
        </div>
        <div className="bmc-body">
          <h3 className="bmc-name">{item.name}</h3>
          {item.description && <p className="bmc-desc">{item.description}</p>}
          <div className="bmc-footer">
            <span className="bmc-price">${parseFloat(item.price).toFixed(2)}</span>
            <button className={`bmc-btn ${added ? 'bmc-btn-added' : ''}`} onClick={handleAdd} style={{ background: primary, borderColor: primary }}>
              {added ? <>✓ Added</> : <>+ Add to Enquiry</>}
            </button>
          </div>
        </div>
      </div>

      {modalOpen && (
        <>
          <div className="bmc-overlay" onClick={() => setModalOpen(false)} />
          <div className="bmc-modal">
            <button className="bmc-modal-close" onClick={() => setModalOpen(false)} style={{ background: primary }}>✕</button>
            <div className="bmc-modal-img">
              {item.imageUrl ? <img src={item.imageUrl} alt={item.name} /> : <div className="bmc-modal-img-empty"><svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ccc" strokeWidth="1.2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21,15 16,10 5,21"/></svg></div>}
              <span className="bmc-modal-cat" style={{ background: primary }}>{item.category}</span>
            </div>
            <div className="bmc-modal-body">
              <h2 className="bmc-modal-name">{item.name}</h2>
              <p className="bmc-modal-price">${parseFloat(item.price).toFixed(2)}</p>
              <p className="bmc-modal-desc">{item.description || 'No description available.'}</p>
              <div className="bmc-modal-divider" />
              <div className="bmc-modal-footer">
                <p className="bmc-modal-note">ℹ Prices are estimates. Final pricing confirmed on enquiry.</p>
                <button className="bmc-modal-add" onClick={handleAdd} style={{ background: primary, borderColor: primary }}>+ Add to Enquiry</button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default BrandMenuCard;
